/**
 * Portal Manta · Breadcrumb
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function Breadcrumb({modo,lote,page,estudo}){
  const PL={dashfin:'Consolidado do Lote',contexto:'Contexto do Lote',servrod:'Serviços × Rodovias',guiagloss:'Guia & Glossário',tipoconsol:'Tipologias × Rodovia',obrasconsol:'Obras × Rodovia',orcparam:'Orçamento Paramétrico Manta',crono:'Cronograma',docs:'Documentos',agente:'Inteligência · Agente',dash:'Dashboard CAPEX',fin:'Financeiro',tip:'Tipologias',tiprod:'Tipologia × Rodovia',obras:'Obras PER'};
  return(<div style={{background:'#fff',borderBottom:'1px solid #DDE2EE',padding:'0 17px',height:36,display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0,boxShadow:'0 1px 3px rgba(30,42,74,.04)'}}>
    <div style={{display:'flex',alignItems:'center',gap:5}}>
      <span style={{fontSize:10.5,color:V.g4}}>Orçamentação</span>
      <span style={{fontSize:10.5,color:V.g4}}>›</span>
      {modo==='lote'?(<>
        <span style={{fontSize:10.5,color:V.g5}}>Formação 01</span>
        <span style={{fontSize:10.5,color:V.g4}}>›</span>
        <span style={{fontSize:10.5,fontWeight:600,color:V.g7}}>{lote.sig}</span>
        <span style={{fontSize:10.5,color:V.g4}}>›</span>
        <span style={{fontSize:10.5,fontWeight:500,color:V.g7}}>{PL[page]||page}</span>
      </>):(<>
        <span style={{fontSize:10.5,color:V.g5}}>Estudos em Andamento</span>
        <span style={{fontSize:10.5,color:V.g4}}>›</span>
        <span style={{fontSize:10.5,fontWeight:600,color:V.g7}}>{estudo?.nome}</span>
        <span style={{fontSize:10.5,color:V.g4}}>·</span>
        <span style={{fontSize:10.5,color:V.g5}}>{estudo?.concessao}</span>
      </>)}
    </div>
    <div style={{display:'flex',alignItems:'center',gap:8}}>
      {modo==='lote'?(<>
        <span style={{background:V.orp,border:`1px solid ${V.orm}`,color:V.br2,padding:'2px 8px',borderRadius:20,fontSize:10,fontWeight:600}}>{lote.fase}</span>
        <span style={{fontSize:10,color:V.g4}}>Base {lote.data_base}</span>
      </>):(<>
        <span style={{background:V.g1,color:V.g5,padding:'2px 8px',borderRadius:20,fontSize:10,fontWeight:600}}>Extrator ANTT</span>
        <span style={{fontSize:10,color:V.g4}}>Criado {estudo?.criado}</span>
      </>)}
    </div>
  </div>);
}

export { Breadcrumb };
export default Breadcrumb;
